import React from "react";
import styled from "styled-components";
import { useGetDashboardMetrics } from "../hooks/useGetDashboardMetrics";
import { DashboardStatsBar, DashboardStatsBarSkeleton } from "../comps/DashboardStatsBar";
import { PrioritiesOverviewSection } from "@/components/analysisModules/TopicClusteringTreeViewV2/PrioritiesOverviewSection";
import { FeaturedReports } from "./FeaturedReports";
import { AskAIWidget } from "./AskAIWidget";
import { DashboardHalves } from "../comps/DashboardHalves";
import { PrioritiesStatCards } from "@/components/analysisModules/TopicClusteringTreeViewV2/PrioritiesStatCards";
import { usePeriodSelection } from "@/components/analysisModules/TopicClusteringTreeViewV2/periodSelection";
import { PeriodSelector } from "@/components/analysisModules/TopicClusteringTreeViewV2/PeriodPicker";

/**
 * The next Dashboard. It opens with the same stats bar the Overview tab
 * carries (documents, % analysed, …); the rest lands here as it is built,
 * and this tab eventually replaces the others.
 *
 * Runs full width like the Topics V2 cards: the dashboard drops its page
 * padding for this tab and the content pads itself by the same amounts the
 * Topics view uses.
 */
const Page = styled.div`
  padding: 20px 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
// The period control's row: top left, above the stats bar — the period,
// and the period its changes are measured against. Pulled a little closer
// to the bar than the page's row gap.
const PeriodRow = styled.div`
  margin-bottom: -0.8rem;
`;

export const NewTab = () => {
  const { data: metrics, isLoading } = useGetDashboardMetrics();
  // The period selection shared with Topics and Priorities (one provider
  // above the routes); the bar and every section below read it too.
  const periodSelection = usePeriodSelection();
  const { period } = periodSelection;
  return (
    <Page>
      <PeriodRow>
        <PeriodSelector id="overview" inline selection={periodSelection} />
      </PeriodRow>
      {isLoading ? (
        <DashboardStatsBarSkeleton cards={7} />
      ) : (
        <DashboardStatsBar metrics={metrics} period={period}>
          <PrioritiesStatCards />
        </DashboardStatsBar>
      )}
      <PrioritiesOverviewSection />
      {/* Featured reports sets this row's height — its strip of report cards
          is a fixed size — and Ask AI fills it and scrolls inside, so a
          streaming answer never moves the page. */}
      <DashboardHalves>
        <FeaturedReports />
        <AskAIWidget />
      </DashboardHalves>
    </Page>
  );
};
